import { opportunityData } from "../../config/homePageUtils";
import Button from "../common/Button";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const OpportunitySection = () => {
  const { language } = useLanguage();
  return (
    <section
      className="relative wave bg-cover bg-center [background-image:url('../../src/assets/images/landing/green-bg.png')]"
      id="opportunity"
    >
      <div className="absolute inset-0 bg-[#018f9b] bg-opacity-30"></div>
      <div className="relative max-w-7xl mx-auto px-4 py-16">
        <div className="flex justify-between items-center mb-10">
          <div>
            <h2 className={`text-3xl font-bold ${language ? 'text-[#FF9810]' : 'text-white'}`}>
              {language
                ? opportunityData.heading.hi
                : opportunityData.heading.en}{" "}
              <span className={`text-3xl font-bold ${language ? 'text-white' : 'text-[#FF9810]'}`}>
                {language
                  ? opportunityData.subHeading.hi
                  : opportunityData.subHeading.en}
              </span>
            </h2>
            <p className="text-white mb-8 leading-relaxed mr-4">
              {language
                ? opportunityData.subText.hi
                : opportunityData.subText.en}
            </p>
          </div>
          <Button
            onClick={() =>
              window.open(
                opportunityData.button.link,
                "_blank",
                "noopener,noreferrer",
              )
            }
            className={`inline-flex items-center ${opportunityData.button.bgColor} text-white px-6 py-3 rounded-full font-400 hover:bg-[#000] transition`}
          >
            {language
              ? opportunityData.button.text.hi
              : opportunityData.button.text.en}{" "}
            <span className="ml-2 text-lg text-white">→</span>
          </Button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 relative services-section">
          {opportunityData.items.map((item, idx) => {
            const Icon = item.icon; // reference the component
            return (
              <div className="relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 max-w-sm h-64 group">
                <div className="absolute inset-0">
                  <img src={item.src} className="w-full h-full object-cover" />
                </div>
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-4 text-center opacity-0 translate-y-6 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 ease-out">
                  <p className="text-lg font-semibold text-white mb-3">
                    {language ? item.title.hi : item.title.en}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OpportunitySection;
